import { render, staticRenderFns } from "./BandejaSeguimiento.vue?vue&type=template&id=8942b0b4&scoped=true"
import script from "./BandejaSeguimiento.vue?vue&type=script&lang=js"
export * from "./BandejaSeguimiento.vue?vue&type=script&lang=js"
import style0 from "./BandejaSeguimiento.vue?vue&type=style&index=0&id=8942b0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8942b0b4",
  null
  
)

export default component.exports